import { render, staticRenderFns } from "./LoadingContacts.vue?vue&type=template&id=230ccd48"
import script from "./LoadingContacts.vue?vue&type=script&lang=js"
export * from "./LoadingContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports